<link rel="stylesheet" href="https://unpkg.com/@progress/kendo-font-icons/dist/index.css" />
<div class="k-overlay" *ngIf="editWinOpen"></div>

<ng-template #windowTitleBar let-win>
  <span class="k-window-title">{{showTitle}}</span>
  <button kendoWindowCloseAction [window]="win"></button>
</ng-template>

<nav class="navbar bg-body-secondary">
  <div class="container-fluid">
    <span class="navbar-brand"><fa-icon class="fa-solid fa-duotone" [icon]="['fad', 'calendar-day']"></fa-icon></span>
    <div>
    </div>
  </div>
</nav>

<!-- <div>
  <p>UserStories</p>
  <p>{{userStories | json}}</p>
</div> -->
<kendo-listview [data]="userStories" containerClass="k-d-flex k-flex-col k-flex-nowrap" style="height: 70vh; overflow: auto;">
  <ng-template kendoListViewItemTemplate let-dataItem="dataItem">
    <!-- <div>{{dataItem | json }}</div> -->
    <current-iteration-item class="product" [selectedUserStoryId]="selectedUserStoryId" [userStory]="dataItem" [storyStatuses]="storyStatus"
      [storyTypes]="storyTypes" [storyPriorities]="storyPriorities" [storyEstimates]="storyEstimates" [users]="users">
    </current-iteration-item>
  </ng-template>
  <ng-template kendoListViewFooterTemplate>
    <div class="footer">
      <span class="reload-text">Footer text</span>
    </div>
  </ng-template>

</kendo-listview>

<kendo-window *ngIf="editWinOpen" (close)="close()" [width]="1000"
  autoFocusedElement="#project_name">
  <kendo-window-titlebar>
    <span class="k-window-title"><span class="k-icon k-font-icon k-icon-xl k-i-form-element">
      </span> {{showTitle}}</span>
    <button kendoWindowCloseAction></button>
  </kendo-window-titlebar>
  <!-- <casi-project [project]="currentItem" [mode]="formMode" (onCancel)="close()"
    (onSave)="onItemSave($event)"></casi-project> -->
</kendo-window>

<!-- <div kendoDialogContainer></div> -->
<div kendoDialogContainer></div>

<!-- <div kendoWindowContainer></div> -->
  <!-- <casi-project [project]="currentItem" [mode]="formMode" (onCancel)="close()"
    (onSave)="onItemSave($event)"></casi-project> -->
